module.exports = __webpack_public_path__ + "8fe8ffe4b5560b458a4c41fcab3a88ec.png";